import {
  getAwaitedReports as getAwaitedReportsApi,
  getAwaitedTransmissions as getAwaitedTransmissionsApi,
  getCrashedEstablishments as getCrashedEstablishmentsApi
} from "../api/exchange";

export async function getAwaitedReports(cnt_id, cnt_id_push) {
  return getAwaitedReportsApi(cnt_id, cnt_id_push);
}

export async function getAwaitedTransmissions(cnt_id, cnt_id_push) {
  return getAwaitedTransmissionsApi(cnt_id, cnt_id_push);
}

export async function getCrashedEstablishments(cnt_id) {
  return getCrashedEstablishmentsApi(cnt_id);
}